// providerFields/TwilioFields.tsx
import React from "react";
import { Input, Tooltip } from "antd";

interface TwilioFieldsProps {
  credentials: any;
  onChange: (key: string, value: string) => void;
}

const TwilioFields: React.FC<TwilioFieldsProps> = ({
  credentials,
  onChange,
}) => {
  return (
    <div className="d-grid" style={{ gap: 10 }}>
      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            Account SID <span className="text-danger">*</span>
          </label>
          <Tooltip title="Twilio Account SID from your console.">
            <i className="ti ti-info-circle text-muted" />
          </Tooltip>
        </div>
        <Input
          placeholder="Account SID *"
          value={credentials.account_sid || ""}
          onChange={(e) => onChange("account_sid", e.target.value)}
        />
      </div>

      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            Auth Token <span className="text-danger">*</span>
          </label>
          <Tooltip title="Twilio Auth Token used to sign API requests.">
            <i className="ti ti-info-circle text-muted" />
          </Tooltip>
        </div>
        <Input.Password
          placeholder="Auth Token *"
          value={credentials.auth_token || ""}
          onChange={(e) => onChange("auth_token", e.target.value)}
        />
      </div>

      <div>
        <div className="d-flex align-items-center justify-content-between mb-1">
          <label className="form-label fw-semibold mb-0">
            Messaging Service SID <span className="text-danger">*</span>
          </label>
          <Tooltip title="Messaging Service SID of the Twilio WhatsApp sender you want to use.">
            <i className="ti ti-info-circle text-muted" />
          </Tooltip>
        </div>
        <Input
          placeholder="Messaging Service SID *"
          value={credentials.messaging_service_sid || ""}
          onChange={(e) => onChange("messaging_service_sid", e.target.value)}
        />
      </div>
    </div>
  );
};

export default TwilioFields;
